import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {
  provideHttpClient,
  withInterceptors,
  withJsonpSupport,
} from '@angular/common/http';
import { provideAngularSvgIcon } from 'angular-svg-icon';

import { routes } from './app.routes';
import { provideDaterangepickerLocale } from './core/daterangepicker/utils/daterangepicker-locale-provider';
import { provideCognitoAuth, provideSharedDomain } from './shared/provider';
import { environment } from '../environments/environment';
import { SpinnerInterceptor } from './shared/interceptors/spinner.interceptor';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { AuthService } from './shared/services/auth.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { DialogOverlayContainer } from './shared/components/ui/dialog/dialog-overlay-container';
import { TechnicalErrorInterceptor } from './shared/interceptors/technical-error.interceptor';
import { SessionExpiredInterceptor } from './shared/interceptors/session-expired.interceptor';

// Register French locale once so DecimalPipe can use 'fr-FR'
registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    AuthService,
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideHttpClient(
      withJsonpSupport(),
      withInterceptors([
        SessionExpiredInterceptor,
        AuthInterceptor,
        SpinnerInterceptor,
        TechnicalErrorInterceptor,
      ]),
    ),
    provideAngularSvgIcon(),
    provideDaterangepickerLocale({
      separator: ' - ',
      applyLabel: 'Okay',
    }),
    provideCognitoAuth({
      region: environment.region,
      userPoolId: environment.userPoolId,
      userPoolWebClientId: environment.webClientId,
      domain: environment.domain,
      scope: environment.scope as unknown as string[],
      redirectSignIn: environment.redirectSignIn,
      redirectSignOut: environment.redirectSignOut,
      responseType: environment.responseType,
    }),
    provideSharedDomain({
      userPoolId: environment.userPoolId,
      webClientId: environment.userPoolId,
      apiUrl: environment.apiUrl,
      xOrigin: environment.xOrigin,
      xUserOrigin: environment.xUserOrigin,
    }),
    {
      provide: OverlayContainer,
      useExisting: DialogOverlayContainer,
    },
  ],
};
